export const RECORDING_MAX_DURATION_SEC = 120;

export const RECORDING_WARNING_AT_SEC = 105;

export const AUDIO_MIME_CANDIDATES = [
  'audio/webm',
  'audio/webm;codecs=opus',
  'audio/mp4',
];

export const WAVEFORM_BAR_HEIGHTS = [
  24, 26.813, 30.063, 24.391, 33.188, 24.016, 53.734, 29.813, 65.219, 52.109,
  84, 41.813, 83.047, 70.297, 39.047,
];

export const WAVEFORM_LOTTIE_VIEW_BOX = {
  x: 105.5,
  y: 121,
  width: 270,
  height: 256,
};

export const WAVEFORM_LOTTIE_VIEW_BOX_SIZE = [
  WAVEFORM_LOTTIE_VIEW_BOX.x,
  WAVEFORM_LOTTIE_VIEW_BOX.y,
  WAVEFORM_LOTTIE_VIEW_BOX.width,
  WAVEFORM_LOTTIE_VIEW_BOX.height,
].join(' ');

export const WAVEFORM_LOTTIE_GROUPS = 3;

export const WAVEFORM_LOTTIE_TOTAL_FRAMES = 60;

export const WAVEFORM_LOTTIE_REST_FRAME = 10;

export const WAVEFORM_MIN_SPEED = 0.4;

export const WAVEFORM_MAX_SPEED = 1.6;
